import React from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Layers } from "lucide-react";

export default function GenericModule() {
  const { code } = useParams();
  const { user } = useAuth();
  return (
    <div data-testid="page-generic-module">
      <h1 className="font-display text-3xl font-extrabold">{code}</h1>
      <p className="text-sm text-zinc-500 mt-1">Modul custom</p>
      <div className="card-flat p-12 mt-8 text-center">
        <Layers size={48} className="mx-auto text-zinc-300" />
        <div className="font-display text-lg font-bold mt-4">Conținut în pregătire</div>
        <p className="text-sm text-zinc-500 mt-2 max-w-md mx-auto">
          Acesta este un modul adăugat dinamic. Funcționalitățile specifice pot fi dezvoltate ulterior.
        </p>
      </div>
    </div>
  );
}
